import PersonalizedPlacement from 'components/PersonalizedPreviewPlacements/PersonalizedPlacement/PersonalizedPlacement';
import { withPersonalizedPlacementProps } from 'viewModel/personalizedPreviewPlacements/withPersonalizedPlacementProps';

export default withPersonalizedPlacementProps(PersonalizedPlacement);
